import React, { memo } from 'react';
import cx from 'classnames';
import { Option } from '../Option/index.js';
import styles from './index.module.scss.js';

const MemoOption = memo(Option);
const OptionsGrid = ({
  innerRef,
  listboxId,
  placeholder,
  isMultiple,
  optionId,
  list,
  selectedIds,
  vevet,
  isActive,
  setFocusedId,
  handleSelect,
  optionKind,
  focusedId,
  checkboxType,
  theme,
  optionsBorderTop,
  renderOption: Option = MemoOption,
  text
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    ref: innerRef,
    role: "listbox",
    id: listboxId,
    "aria-label": placeholder,
    "aria-multiselectable": isMultiple,
    tabIndex: -1,
    className: cx(styles.box, "select__options-box", {
      [styles["border-top"]]: optionsBorderTop
    })
  },
  list.map((topOption) => {
    if ("options" in topOption) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: topOption.id,
          className: cx(styles.box, "select__options-grid")
        },
        topOption.name && /* @__PURE__ */ React.createElement("div", { className: styles["group-name"] }, topOption.name),
        topOption.options.map((subOption) => /* @__PURE__ */ React.createElement(
          "div",
          {
            tabIndex: 0,
            key: subOption.id,
            role: "option",
            id: `${optionId}-${subOption.id}`,
            "aria-selected": selectedIds.includes(subOption.id),
            onMouseEnter: () => !vevet.isMobile && isActive && setFocusedId(subOption.id),
            onClick: () => handleSelect(subOption.id),
            className: cx(
              styles["option-wrapper"],
              "select__option-wrapper",
              {
                [styles.checkbox]: checkboxType,
                [styles.selected]: selectedIds.includes(subOption.id)
              }
            )
          },
          /* @__PURE__ */ React.createElement(
            Option,
            {
              ...subOption,
              id: subOption.id,
              $kind: optionKind,
              $isFocused: subOption.id === focusedId,
              $isSelected: selectedIds.includes(subOption.id),
              $theme: theme,
              labelBet: text?.bet
            }
          )
        ))
      );
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        tabIndex: 0,
        key: topOption.id,
        role: "option",
        id: `${optionId}-${topOption.id}`,
        "aria-selected": selectedIds.includes(topOption.id),
        onMouseEnter: () => isActive && setFocusedId(topOption.id),
        onClick: () => handleSelect(topOption.id),
        className: cx(styles["option-wrapper"], "select__option-wrapper", {
          [styles.checkbox]: checkboxType,
          [styles.selected]: selectedIds.includes(topOption.id)
        })
      },
      /* @__PURE__ */ React.createElement(
        Option,
        {
          ...topOption,
          id: topOption.id,
          $kind: optionKind,
          $isFocused: topOption.id === focusedId,
          $isSelected: selectedIds.includes(topOption.id),
          $theme: theme,
          labelBet: text?.bet
        }
      )
    );
  })
);

export { OptionsGrid };
//# sourceMappingURL=index.js.map
